import { render, staticRenderFns } from "./ReviewDashboardAmbulatory.vue?vue&type=template&id=4aa04046&scoped=true&"
import script from "./ReviewDashboardAmbulatory.vue?vue&type=script&lang=js&"
export * from "./ReviewDashboardAmbulatory.vue?vue&type=script&lang=js&"
import style0 from "./ReviewDashboardAmbulatory.vue?vue&type=style&index=0&id=4aa04046&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa04046",
  null
  
)

export default component.exports